import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const LIST_TCF_VENDOR_SYMBOL = Symbol();
const useListTcfVendor = ()=>useImmutableContext(LIST_TCF_VENDOR_SYMBOL);
const useListTcfVendorProvider = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return useImmutableContextProvider(LIST_TCF_VENDOR_SYMBOL, ...args);
};
export { useListTcfVendor, useListTcfVendorProvider };
